import { IssueSeverity } from '@kcftech/prometheus-client';
import { SeverityLozenge } from 'pages/Desk/issues/issue_card/SeverityLozenge';
import { IssueSeverities } from 'pages/Desk/issues/shared';
import { useMemo } from 'react';
import { MultiSelectQuickFilterButton } from 'shared/filter_pane/MultiSelectQuickFilterButton';
import { sortBy } from 'utils/array';

// Map API enum to numeric severity values that SeverityLozenge expects
const severityEnumToValue: Record<IssueSeverity, number> = {
    [IssueSeverity.Low]: 0,
    [IssueSeverity.Moderate]: 0.5,
    [IssueSeverity.Severe]: 1,
};

export type SeverityFilterButtonProps = {
    severities: IssueSeverity[];
    onChangeSeverities: (severities: IssueSeverity[]) => void;
};

export function SeverityFilterButton({
    severities,
    onChangeSeverities,
}: SeverityFilterButtonProps) {
    const options = useMemo(
        () =>
            // Sort by the order in IssueSeverities array (Severe, Moderate, Low)
            sortBy(Object.values(IssueSeverity), (s) => {
                const severityObj = IssueSeverities.find((is) => is.label === s);
                return severityObj ? -severityObj.severityValue : 0;
            }).map((severity) => ({
                value: severity,
                label: <SeverityLozenge severity={severityEnumToValue[severity]} />,
            })),
        [],
    );

    return (
        <MultiSelectQuickFilterButton
            id="severity-filter"
            label="Severity"
            selectedValues={severities}
            onChangeValues={onChangeSeverities}
            options={options}
        />
    );
}
